import { render, staticRenderFns } from "./agingStockStats.vue?vue&type=template&id=0d92071a&"
import script from "./agingStockStats.vue?vue&type=script&lang=js&"
export * from "./agingStockStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports